import ALGO from '../assets/images/wallets/ALGO.svg';
import { PoolState } from '../interfaces';
import { BLOCKCHAINS, WH_PROVIDER_CHAIN_ID } from '../wallets/providers';

export const OrderType = {
  Limit: 'L',
  IOC: 'I',
  Post: 'P',
  Market: 'M',
  LimitNumber: 0,
  IOCNumber: 1,
  PostNumber: 2,
  MarketNumber: 3,
};

Object.freeze(OrderType);

const successOrderMessages = {
  L: 'success_msg.create_limit_order_successful',
  I: 'success_msg.create_IOC_order_successful',
  P: 'success_msg.create_Post_order_successful',
  //TBD
  //"M": ""
};

export const getSuccessOrderMessage = (literalType) =>
  successOrderMessages[literalType];

const orderTypeViewString = {
  0: 'Limit',
  1: 'IOC limit',
  2: 'Post-only limit',
  3: 'Market',
  L: 'Limit',
  I: 'IOC',
  P: 'Post',
  M: 'Market',
};

Object.freeze(orderTypeViewString);

export const getOrderTypeViewString = (intType: number | string) =>
  orderTypeViewString[intType];

export const Breakpoint = {
  XSmall: 'xs',
  Small: 'sm',
  Medium: 'md',
  Large: 'lg',
};

Object.freeze(Breakpoint);

export const OrderSide = {
  Sell: 'S',
  Buy: 'B',
  BuySell: 'BS',
  BuyNumber: 0,
  SellNumber: 1,
  BuySellNumber: 3,
} as const;

Object.freeze(OrderSide);

export const OrderSideString = {
  S: 'Sell',
  B: 'Buy',
  0: 'Buy',
  1: 'Sell',
};

Object.freeze(OrderSideString);

export const Notification = {
  SelfTrade: 1,
  FullFilled: 2,
  FullCancelled: 3,
  PartiallyCancelled: 4,
  Created: 5,
};

export const OrderFilterType = {
  All: 'All',
  CurrentPair: 'CurrentPair',
};

Object.freeze(OrderFilterType);

export const HistoryOrderTypes = {
  0: 'Limit',
  1: 'IOC',
  2: 'Post-only',
  3: 'Market',
};

export enum OrderTypeEnum {
  'Limit',
  'IOC',
  'POST',
  'Market',
}

export enum OrderStatus {
  'Open' = 1,
  'Canceled',
  'Completed',
  'SelfMatch',
  'Expired',
}

export enum OrderExecution {
  'open' = 1,
  'close',
}

export enum OrderUpdateStaus {
  'created' = 1,
  'partially_filled',
  'removed',
}

export enum OrderExecutionType {
  open = "open",
  close = "close",
}

export enum LastTradeStatus {
  Pending = "Pending",
  Confirmed = "Confirmed",
  Rejected = "Rejected"
};

export enum UserTradeStatus {
  Unconfirmed = "UNCONFIRMED",
  Confirmed = "CONFIRMED",
  Rejected = "REJECTED",
}

export type OrderSideShort = "B" | "S";

export interface ITradeDto {
  tradeId: number,
  amount: string,
  price: string,
  createdAt: number,
  updatedAt?: number,
  total?: string,
  orderId?: number,
  orderSide?: OrderSideShort,
  pairId?: number,
  baseTokenId?: number,
  baseTokenDecimal?: number,
  quoteTokenId?: number,
  quoteTokenDecimal?: number,
  status?: string,//UserTradeStatus | LastTradeStatus,
  fee?: string,
  isBuyer?: boolean,
  isMaker?: boolean,
}

export interface IOrderDto {
  id: number,
  pairId: number,
  pair: string,
  status: OrderStatus,
  side: 0 | 1;
  type: OrderTypeEnum,
  price: string,
  amount: string,
  filledAmount: string,
  total: string,
  filledTotal: string,
  avgPrice: string,
  userId: string,
  createdAt: number,
  updatedAt?: number,
  completedAt?: number;
  trades?: ITradeDto[],
}

export interface Order extends IOrderDto {
  executed: boolean;
  updateStatus?: OrderUpdateStaus,
  base_currency: string;
  base_decimal: number;
  price_currency: string;
  price_decimal: number;
  min_size_increment: string;
  min_price_increment: string;
  price_id: number;
}

export interface AssetType {
  id: number,
  index: number | `0x${string}` | string;
  name: string | null;
  decimal: number;
  img: string;
  amount: string;
  unit_name: string | null;
  reputation?: Reputation;
  usd_value?: number;
  chainId?: number;
}

export interface AccountAssetType {
  id: number,
  index: string;
  name: string | null;
  decimal: number;
  img: string;
  amount: string;
  lockedAmount: string;
  unit_name: string | null;
  chainId: number;
  usd_value?: number;
  isWrapped?: boolean;
}

export interface CodexBalanceDto {
  hash: string,
  loginAddress: string,
  loginChainId: number,
  tokenId: number,
  tokenAddress: string,
  tokenChainId: number,
  amount: string,
  lockedAmount: string
}

export interface CodexBalance {
  loginAddress: string,
  loginChainId: number,
  tokenId: string,
  tokenChainId: number,
  availableAmount: string,
  lockedAmount: string
}

export interface IndexerAsset {
  'created-at-round': number;
  deleted: boolean;
  index: number;
  params: IndexerAssetParams;
}

export interface IndexerAssetParams {
  clawback: string;
  creator: string;
  decimals: number;
  'default-frozen': boolean;
  freeze: string;
  manager: string;
  name: string;
  'name-b64': string;
  reserve: string;
  total: number;
  'unit-name': string;
  'unit-name-b64': string;
  verification: any;
}

export enum Reputation {
  Verified = 0,
  Notable,
  Neutral,
  Unverified,
  Deprecated,
  Unsafe,
  Scam,
  Destroyed,
}

export const ALGORAND_ASSET = {
  index: 0,
  name: 'Algorand',
  unit_name: 'ALGO',
  img: ALGO,
  decimal: 6,
  chainId: WH_PROVIDER_CHAIN_ID[BLOCKCHAINS.ALGORAND]
};

export interface PoolStateRedis {
  appId: number;
  asset1Amount: string;
  asset2Amount: string;
  issuedAmount: string;
  fee: number;
}
export interface AssetAPI {
  id: string;
  unitName: string | null;
  name: string | null;
  imgUrl: string | null;
  decimals: number;
  minDispnse: number | null;
  maxDispnse: number | null;
  creator: string | null;
  total: number | null;
  defaultFrozen: boolean;
  url: string | null;
}
export interface PoolAPI {
  id: number;
  asset1Id: AssetAPI;
  asset2Id: AssetAPI;
  poolTokenId: AssetAPI;
  lastDayFee: number;
  lastDayVolume: number;
  weeklyApy: number | null;
  poolState: PoolState;
  tvlUsdPrice: number;
  usdTvlAsset1: number;
  usdTvlAsset2: number;
  dayBeforeFee: number;
  dayBeforeVolume: number;
  weeklyApyBefore: number;
}

export interface IPOOL {
  poolId: number;
  poolTokenId: number;
  poolTokenDecimals: number;
  poolState: PoolState;
  aId: string;
  aReputation: Reputation;
  aDecimals: number;
  aName: string;
  aImg: string;
  aUnitName: string;
  bId: string;
  bDecimals;
  bReputation: Reputation;
  bName: string;
  bImg: string;
  bUnitName: string;
  lastDayFee: number;
  lastDayVolume: number;
  weeklyApy: number | null;
  tvlUsdPrice: number;
  usdTvlAsset1: number;
  usdTvlAsset2: number;
  dayBeforeFee: number;
  dayBeforeVolume: number;
  weeklyApyBefore: number;
}

export enum AmmList {
  Ultrade,
  Tinyman,
  Pactfi,
  Humble,
  Algofi,
}

export interface RouteWithAmount {
  assetA: number;
  assetB: number;
  pools: PoolWithAmounts[];
}
export interface Swap {
  splitAmt: number;
  route: RouteWithAmount;
}

export interface SwapData {
  receiveAmt: number;
  swaps: Swap[];
  txns?: string[];
  fee?: number;
  message? : string;
}

export type BestSwaps = {
  splitAmt: number;
  route: Route;
};

export interface Pool {
  amm: number;
  appID: number;
  assetA: number;
  assetB: number;
  fee: number;
}

export interface PoolWithAmounts extends Pool {
  assetA_amount: number;
  assetB_amount: number;
  foreign_resources: number;
}

export interface Route {
  assetA: number;
  assetB: number;
  pools: Pool[];
}

export enum ResponseMessages {
  NO_CONTENT = 'No Content',
  NOT_FOUND = 'Routes not found',
  CANCELL = 'Operation cancelled',
}

export interface BaseResponse<T> {
  count: number;
  next: number | null;
  previous: number | null;
  result: T;
}

export interface S3Asset {
  [key: number]: AssetAPI;
}

export interface CodexAsset {
  id: number,
  address: string,
  chainId: number,
  unitName: string,
  name: string,
  decimals: number,
  img: string,
  cmcLink: string,
  isGas: boolean,
}

export type ParsedAccountData = {
  info: ParsedAccountInfo;
  type: string;
};

type ParsedAccountInfo = {
  isNative: boolean;
  mint: string;
  owner: string;
  state: string;
  tokenAmount: TokenAmount;
};

type TokenAmount = {
  amount: string;
  decimals: number;
  uiAmount: number;
  uiAmountString: string;
};
